export default __webpack_public_path__ + "static/media/sampleBuild.10cd2c06.png";